var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('div',{staticClass:"box_one",staticStyle:{"margin-bottom":"5px"}},[_c('cont-top')],1),_c('div',{staticClass:"box_one",staticStyle:{"margin-bottom":"5px"}},[_c('cont-one')],1),_c('div',{staticClass:"box_one"},[_c('cont-bottom')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }